// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { Integrations } from '@sentry/tracing';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const TRACES_SAMPLE_RATE = process.env.NEXT_PUBLIC_TRACES_SAMPLE_RATE;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://7617b3df5ddd40b189a763ed7deaf7e8@o373149.ingest.sentry.io/5784568',
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: TRACES_SAMPLE_RATE || 1.0,
});
